/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_More_TitleInputs */

const en_directory_mcp_more_title = /** @type {(inputs: Directory_Mcp_More_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep reading`)
};

const zh_directory_mcp_more_title = /** @type {(inputs: Directory_Mcp_More_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`延伸阅读`)
};

/**
* | output |
* | --- |
* | "Keep reading" |
*
* @param {Directory_Mcp_More_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_more_title = /** @type {((inputs?: Directory_Mcp_More_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_More_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_more_title(inputs)
	return zh_directory_mcp_more_title(inputs)
});
export { directory_mcp_more_title as "directory.mcp.more_title" }